import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { Typography } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";

export const PrintPermissionsModal: FC<{
  onClose: () => void;
  onConnect: () => void | Promise<void>;
  onUseLaser: () => void | Promise<void>;
}> = ({ onClose, onConnect, onUseLaser }) => {
  const { formatMessage } = useIntl();
  return (
    <DialogContainer open onClose={onClose}>
      <DialogHeader title="">
        <Typography variant="h5" component="h2" style={{ fontWeight: "bold" }}>
          {formatMessage({
            id: "invoice.printModal.permission.title",
            defaultMessage: "Thermal Printing",
          })}
        </Typography>
        <Typography variant="subtitle2">
          <FormattedMessage
            id="invoice.printModal.permission.subtitle"
            defaultMessage="We need your permission to access the printer"
          />
        </Typography>
      </DialogHeader>
      <DialogBody>
        <Typography variant="body2" data-testid="thermal-permission">
          <FormattedMessage
            id="invoice.printModal.permission.message"
            defaultMessage='Please click "Connect" and select your printer. You will not be prompted in future.'
          />
        </Typography>
      </DialogBody>
      <DialogFooter>
        <Button color="secondary" onClick={onClose}>
          <FormattedMessage
            id="invoice.printModal.permission.actions.cancel"
            defaultMessage="Cancel"
          />
        </Button>
        <Button color="secondary" onClick={onUseLaser}>
          <FormattedMessage
            id="invoice.printModal.permission.actions.laser"
            defaultMessage="Use Laser Printer"
          />
        </Button>
        <Button color="primary" onClick={onConnect}>
          <FormattedMessage
            id="invoice.printModal.permission.actions.connect"
            defaultMessage="Connect"
          />
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
};
